import {
    CARGAR_CONSULTORIOS_PROFESIONAL,
    CARGAR_CONSULTORIOS_PROFESIONAL_EXITO,
    CREAR_CONSULTORIO_PROFESIONAL_EXITO,
    EDITAR_CONSULTORIO_PROFESIONAL_EXITO,
    BORRAR_CONSULTORIO_PROFESIONAL_EXITO
} from '../types';

import clienteAxios from '../config/axios';

import {
    setearAlerta
} from './alertaActions';


// =========================
// HELPERS
// =========================

// Centralizamos el mensaje de error porque backend puede responder
// con msg o con message según el endpoint.
const obtenerMensajeError = (error, mensajeDefault) => {

    return (
        error?.response?.data?.msg ||
        error?.response?.data?.message ||
        mensajeDefault
    );

};


// =========================
// CARGAR CONSULTORIOS
// =========================

export function cargarConsultoriosProfesionalAction(informacion) {

    return async (dispatch) => {

        dispatch(
            cargarConsultoriosProfesional()
        );

        try {

            const { config } = informacion;

            const respuesta = await clienteAxios.get(
                '/usuarios/consultorios',
                config
            );

            const consultorios = Array.isArray(respuesta.data?.consultorios)
                ? respuesta.data.consultorios
                : [];

            dispatch(
                cargarConsultoriosProfesionalExito(consultorios)
            );

            return consultorios;

        } catch (error) {

            console.log(error.response);

            dispatch(
                setearAlerta({
                    msg: obtenerMensajeError(
                        error,
                        'No se pudieron cargar los consultorios.'
                    )
                })
            );

            dispatch(
                cargarConsultoriosProfesionalExito([])
            );

            return [];

        }

    };

}


// =========================
// CREAR CONSULTORIO
// =========================

export function crearConsultorioProfesionalAction(informacion) {

    return async (dispatch) => {

        try {

            const { config, payload } = informacion;

            const respuesta = await clienteAxios.post(
                '/usuarios/consultorios/crear',
                payload,
                config
            );

            dispatch(
                crearConsultorioProfesionalExito(
                    respuesta.data?.consultorio
                )
            );

            dispatch(
                setearAlerta({
                    msg: respuesta.data?.msg || 'Consultorio creado correctamente.'
                })
            );

            return true;

        } catch (error) {

            console.log(error.response);

            dispatch(
                setearAlerta({
                    msg: obtenerMensajeError(
                        error,
                        'No se pudo crear el consultorio.'
                    )
                })
            );

            return false;

        }

    };

}


// =========================
// EDITAR CONSULTORIO
// =========================

export function editarConsultorioProfesionalAction(informacion) {

    return async (dispatch) => {

        try {

            const { config, payload } = informacion;

            const respuesta = await clienteAxios.post(
                '/usuarios/consultorios/editar',
                payload,
                config
            );

            dispatch(
                editarConsultorioProfesionalExito(
                    respuesta.data?.consultorio
                )
            );

            dispatch(
                setearAlerta({
                    msg: respuesta.data?.msg || 'Consultorio editado correctamente.'
                })
            );

            return true;

        } catch (error) {

            console.log(error.response);

            dispatch(
                setearAlerta({
                    msg: obtenerMensajeError(
                        error,
                        'No se pudo editar el consultorio.'
                    )
                })
            );

            return false;

        }

    };

}


// =========================
// BORRAR CONSULTORIO
// =========================

export function borrarConsultorioProfesionalAction(informacion) {

    return async (dispatch) => {

        try {

            const { config, payload } = informacion;

            const respuesta = await clienteAxios.post(
                '/usuarios/consultorios/borrar',
                payload,
                config
            );

            dispatch(
                borrarConsultorioProfesionalExito(
                    payload.id
                )
            );

            dispatch(
                setearAlerta({
                    msg: respuesta.data?.msg || 'Consultorio eliminado correctamente.'
                })
            );

            return true;

        } catch (error) {

            console.log(error.response);

            dispatch(
                setearAlerta({
                    msg: obtenerMensajeError(
                        error,
                        'No se pudo eliminar el consultorio.'
                    )
                })
            );

            return false;

        }

    };

}


// =========================
// ACTION CREATORS
// =========================

const cargarConsultoriosProfesional = () => ({

    type: CARGAR_CONSULTORIOS_PROFESIONAL

});


const cargarConsultoriosProfesionalExito = (dato) => ({

    type: CARGAR_CONSULTORIOS_PROFESIONAL_EXITO,
    payload: dato

});


const crearConsultorioProfesionalExito = (dato) => ({

    type: CREAR_CONSULTORIO_PROFESIONAL_EXITO,
    payload: dato

});


const editarConsultorioProfesionalExito = (dato) => ({

    type: EDITAR_CONSULTORIO_PROFESIONAL_EXITO,
    payload: dato

});


const borrarConsultorioProfesionalExito = (dato) => ({

    type: BORRAR_CONSULTORIO_PROFESIONAL_EXITO,
    payload: dato

});